import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbAlertModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import {
  GridWrapperModule,
  TableLayoutModule,
} from '@northfork/ag-grid-angular'
import {
  ButtonModule,
  DateModule,
  DatepickerModule,
  LoaderModule,
  NfFormsModule,
  RadioModule,
} from '@northfork/ng-basics'
import { BulkExternalTransactionsPanelComponent } from './bulk-external-transactions-panel.component'
import { BulkExternalTransactionsGridComponent } from './components/bulk-external-transactions-grid/bulk-external-transactions-grid.component'
import { FindTransactionsPopoverComponent } from './components/find-transactions-popover/find-transactions-popover.component'
import { BulkExternalTransactionsService } from './services/bulk-external-transactions-service/bulk-external-transactions.service'

@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    NgbPopoverModule,
    GridWrapperModule,
    LoaderModule,
    ButtonModule,
    NfFormsModule,
    FormsModule,
    ReactiveFormsModule,
    RadioModule,
    DateModule,
    DatepickerModule,
    NgSelectModule,
    NgbAlertModule,
  ],
  declarations: [
    BulkExternalTransactionsPanelComponent,
    BulkExternalTransactionsGridComponent,
    FindTransactionsPopoverComponent,
  ],
  providers: [BulkExternalTransactionsService],
  exports: [BulkExternalTransactionsPanelComponent],
})
export class BulkExternalTransactionsModule {}

export { BulkExternalTransactionsPanelComponent }
